import { ArrowRight, Leaf, Route, Sparkles } from "lucide-react";
import { T } from "@/i18n";

const HERO_IMG = "https://images.unsplash.com/photo-1588421033046-d7c051d496eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

const stats = [
  { icon: Sparkles, label: "Itinerari su misura", id: "hero-stat-ai" },
  { icon: Leaf, label: "TS Impact Score 0–100", id: "hero-stat-tis" },
  { icon: Route, label: "Quartieri fuori dalle trappole turistiche", id: "hero-stat-areas" },
];

export const Hero = () => (
  <section data-testid="hero-section" className="no-print grain relative isolate min-h-[92vh] overflow-hidden bg-gray-900">
    <img src={HERO_IMG} alt="Paesaggio naturale verde" className="absolute inset-0 -z-10 h-full w-full object-cover" />
    <div className="absolute inset-0 -z-10 bg-gradient-to-r from-gray-950/85 via-emerald-950/60 to-emerald-900/10" />
    <div className="mx-auto flex min-h-[92vh] max-w-7xl flex-col justify-end px-6 pb-20 pt-36 md:px-10 md:pb-28">
      <p className="rise text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300"><T>tripsaver.it · travel planning sostenibile</T></p>
      <h1 data-testid="hero-title" className="rise d1 mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        <T>Crea il tuo itinerario di viaggio </T><span className="text-emerald-300"><T>su misura in 30 secondi.</T></span>
      </h1>
      <p data-testid="hero-subtitle" className="rise d2 mt-6 max-w-xl text-base text-white/80 md:text-lg">
        <T>Scopri mete uniche, evita il turismo di massa e risparmia tempo nella pianificazione. Senza stress.</T>
      </p>
      <div className="rise d3 mt-10 flex flex-col items-start gap-3">
        <a href="#crea-viaggio" data-testid="hero-cta-button"
          className="group inline-flex items-center gap-3 rounded-full bg-emerald-500 px-7 py-4 font-semibold text-white shadow-lg shadow-emerald-900/40 transition-[background-color,transform] duration-200 hover:bg-emerald-400 active:scale-[0.98]">
          <T>Genera il tuo viaggio gratis</T>
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </a>
        <span data-testid="hero-no-signup-note" className="pl-2 text-sm text-white/60"><T>Nessuna registrazione richiesta.</T></span>
      </div>
      <div className="rise d4 mt-16 grid max-w-3xl gap-3 sm:grid-cols-3">
        {stats.map(({ icon: Icon, label, id }) => (
          <div key={id} data-testid={id} className="flex items-center gap-3 rounded-2xl bg-white/10 px-4 py-3 text-sm text-white/90 ring-1 ring-white/15 backdrop-blur-md">
            <Icon className="h-4 w-4 shrink-0 text-emerald-300" /> <T>{label}</T>
          </div>
        ))}
      </div>
    </div>
  </section>
);
